<template>
  <home/>
</template>
<script>
import Home from './views/Home.vue'
export default {
  components: {
    Home
  }
}
</script>
<style lang="less">
@import './assets/css/mixins.less';

</style>
